import { Link } from '@on3/ui-lib/components/Link';
import {
  FaqItem,
  type FaqItemProps,
} from '@public/components/Join/Faq/FaqItem';

import styles from './JoinFaq.module.scss';

const questions: FaqItemProps[] = [
  {
    key: 1,
    question: 'What is an On3 Plus (Premium) article?',
    lineOne:
      "An article receives the 'On3 Plus' label when it offers exclusive information or content enhanced by the expertise of an On3 reporter. These articles typically include: In-depth observations and breakdowns, expert rankings and lists, thorough analysis not available anywhere else, exclusive one-on-one interviews with coaching staff/players/recruits, insider information on team and recruiting, news and Information only available at On3 and Name, Image, Likeness “NIL”, news and info.",
  },
  {
    key: 2,
    question: 'Why should college sports fans care about On3 Plus content?',
    lineOne:
      "On3 Plus content is  exclusive, high-quality information that goes beyond what you would find anywhere else. The On3 Plus label guarantees in-depth observations, expert rankings, thorough analysis, and one-on-one interviews, giving fans a more comprehensive understanding of their favorite teams and athletes. Furthermore, the insider information on team and recruiting, as well as news and information only available at On3, ensures fans receive unique insights they can't find anywhere else. This makes On3 Plus content an invaluable resource for passionate and well-informed college sports fans.",
  },
  {
    key: 3,
    question: 'Why is there a paywall on On3 Plus articles?',
    lineOne:
      'We want our paying subscribers to always be the smartest, in-the-know fans across the country - and our commitment to deliver on that promise starts with only allowing you - our paying subscribers - exclusive access to content that no one else has access to.  The significant investment required to hire the best reporters in the industry and building experiences (i.e. insider opinion, message boards, NIL content, databases access, etc.) requires the support of our paying subscribers.',

    lineTwo:
      'Our talented reporters provide in-depth analysis, exclusive interviews, and expert insights, which are the foundation of the high-quality content On3 Plus offers. As a start-up, On3 allocates all of the revenue generated from subscriptions to continually improve the product. The paywall also allows On3 to expand coverage across all major college programs ensuring that we bring the most comprehensive college football coverage and content experience for all team fans across the country. By supporting On3 through subscriptions, fans are not only gaining access to exclusive content but also enabling the platform to grow and deliver even better sports journalism. Ultimately, the paywall ensures that On3 can continue to provide top-tier content while maintaining its commitment to excellence and innovation in sports journalism.',
  },
  {
    key: 4,
    question: 'What are the message boards?',
    lineOne:
      'The On3 fan site message boards are online platforms where fans of college sports can gather to discuss, share, and engage with one another on various topics related to their favorite teams, players, games, recruiting and more. ',
    lineTwo:
      'As a paying subscriber you will have full access to the message boards - and will be able to view and provide comments and engage with fellow fans. Non-paying users do not have commenting access.',
  },
  {
    key: 5,
    question: 'How do I get the On3 mobile app?',
    lineOne: (
      <>
        Go to{' '}
        <Link href="https://www.on3.com/apps/on3/">
          https://www.on3.com/apps/on3/
        </Link>
        .
      </>
    ),
  },
];

export const JoinFaq = () => {
  return (
    <section className={styles.block}>
      <h2 className={styles.title}>Frequently asked questions</h2>
      <ul>
        {questions.map((question) => (
          <FaqItem {...question} key={question.key} />
        ))}
      </ul>
    </section>
  );
};
